// src/components/CenteredForm.js
import { useState } from 'react'
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import "./ComplianceFormStyle.css"
import { Link } from 'react-router-dom';

export const ComplianceForm = () => {
    const [validated, setValidated] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [formData, setFormData] = useState({
        nome: "",
        email: "",
        mensagem: ""
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            setSubmitted(true);

            // 🔑 Filtra campos vazios (nome/email) antes de enviar
            const payload = {};
            if (formData.nome.trim() !== "") payload.nome = formData.nome;
            if (formData.email.trim() !== "") payload.email = formData.email;
            payload.mensagem = formData.mensagem; // sempre obrigatório

            try {
                const response = await fetch("https://compliance.se77e.com.br/api/compliance-form", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    throw new Error("Erro ao enviar o formulário");
                }

                const data = await response.json();
                console.log("Resposta da API:", data);

            } catch (error) {
                console.error("Erro:", error);
            }
        }

        setValidated(true);
    };

    return (
        <Container fluid className="centered-form-container">
            <Card className="centered-form-card">
                <h2 className="mb-4 text-center">Formulário</h2>
                <p className="mb-4 text-center">
                    Este é um canal aberto direto com nosso Compliance. Sua denúncia será analisada o mais rápido possível.
                </p>

                {/* Mensagem de sucesso */}
                {submitted && (<>
                    <Alert variant="success" className="text-center">
                        Enviado com sucesso! Nossa equipe irá analisar o mais rápido possível sua denúncia.
                    </Alert>

                    <Button as={Link} to="/" variant="primary" className="centered-form-card w-100">
                        Página principal
                    </Button>

                </>


                )}

                {/* Formulário */}
                {!submitted && (
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formName">
                            <Form.Label>Nome (opcional)</Form.Label>
                            <Form.Control type="text" placeholder="Digite seu nome" name="nome" value={formData.nome} onChange={handleChange} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Label>Email (opcional)</Form.Label>
                            <Form.Control type="email" placeholder="Digite seu email" name="email" value={formData.email} onChange={handleChange} />
                        </Form.Group>

                        <Form.Group className="mb-4" controlId="formMessage">
                            <Form.Label>Mensagem*</Form.Label>
                            <Form.Control as="textarea" rows={4} placeholder="Digite sua mensagem" name="mensagem" value={formData.mensagem} onChange={handleChange} required />
                            <Form.Control.Feedback type="invalid">
                                Este campo é obrigatório.
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Button variant="primary" type="submit" className="w-100">
                            Enviar
                        </Button>
                    </Form>
                )}
            </Card>
        </Container>
    );
};
